import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';

import {
  PENDING_IDENTITIES,
  PUT_PENDING_IDENTITY,
} from './Api';


const SET_IDENTITIES = 'cam4/studio/SET_IDENTITIES';
const UPDATE_IDENTITY = 'cam4/studio/UPDATE_IDENTITY';

const initialState = Immutable.fromJS({ identities: [] });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_IDENTITIES:
      return state.set('identities', Immutable.fromJS(action.identities));

    case UPDATE_IDENTITY:
      return state.set(
        'identities',
        state.get('identities').filter((o) => o.get('id') !== action.identity.id)
      );

    default:
      return state;
  }
}

export const NAME = 'verificationQueue';

const identities = (state) => state[NAME].get('identities');

export const selector = createStructuredSelector({ identities });

function displayPendingIdentities(res) {
  return {
    type: SET_IDENTITIES,
    identities: res.data,
  };
}

function updateIdentityList(identity) {
  return {
    type: UPDATE_IDENTITY,
    identity,
  };
}

function getPendingIdentities() {
  return (dispatch) =>
    ApiService
      .get(PENDING_IDENTITIES)
      .then((res) => dispatch(displayPendingIdentities(res)));
}

function updatePendingIdentity(identity) {
  const { id, username, name, identityType, status } = identity;
  const data = {
    id,
    username,
    name,
    identityType,
    status,
  };

  return (dispatch) =>
    ApiService
      .put(PUT_PENDING_IDENTITY, { data })
      .then(() => dispatch(updateIdentityList(identity)));
}

export const actionCreators = {
  getPendingIdentities,
  updatePendingIdentity,
};
